.se-container-wide {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 15px;
  padding-right: 15px;
}

@media screen and (min-width: 980px) {
  .se-container-wide {
    padding-left: 10px;
    padding-right: 10px;
  }
}

:host {
  display: block;
  box-sizing: border-box;
}

:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}

@media screen and (min-width: 980px) {
  .envdetail__section {
    width: 372px;
    height: auto;
  }

  :host(:not([dir="rtl"])) .envdetail__section {
    margin-right: 32px;
  }

  :host([dir="rtl"]) .envdetail__section {
    margin-left: 32px;
  }
}

@media screen and (max-width: 979px) {
  .envdetail__section {
    width: 100%;
    height: auto;
    margin-bottom: 16px;
  }
}

:host([dir=rtl]) .sc-pes-environmental-detail .qds-standalone-link {
  flex-direction: row-reverse;
}

.environmental__link {
  color: #55d1fe;
}

@media screen and (min-width: 980px) {
  .environmental__link {
    margin-bottom: 16px;
  }
}

.qds-standalone-link .sc-pes-environmental-detail {
  color: #0075a3;
}

.envdata__description {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #626469;
}

@media screen and (min-width: 980px) {
  .envdata__description {
    margin-bottom: 16px;
  }
}

@media screen and (max-width: 719px) {
  .envdata__description {
    padding: 8px 0px 8px 0px;
  }
}